import map from "lodash/map";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Table from "../../Common/Tables/BaseTable";
import OvertredelseskoderIleggelserUpdateModal from "./UpdateModals/OvertredelseskoderIleggelseModal";

import { getOvertredelserkoderIleggelser } from "../../../actions/overtredelseskoderIleggelserActions";
import getOvertredelseskoderIleggelserList from "../../../selectors/overtredelseskoderIleggelserSelector";

import { authorized } from "../../../utils/authorizationUtils";
import { sanitizeHtml } from "../../../utils/sanitizationUtils";

import { juridiskAll } from "../../../constants/roles";
import * as title from "../../../constants/titles";

import { faCaretDown, faCaretRight } from "@fortawesome/free-solid-svg-icons";

export default function OvertredelseskoderIleggelseList({
  authorizedToCreateAndEdit,
}) {
  const dispatch = useDispatch();
  const overtredelseskoderIleggelser = useSelector((state) =>
    state.overtredelseskoderIleggelser
      ? getOvertredelseskoderIleggelserList(state)
      : undefined,
  );
  const [valgtOvertredelseId, setValgtOvertredelseId] = useState(undefined);
  const [updateModalIsOpen, setUpdateModalIsOpen] = useState(false);

  useEffect(() => {
    document.title = title.overtredelseskoderIleggelser;
    dispatch(getOvertredelserkoderIleggelser());
  }, [dispatch]);

  const toggleDetailRow = (overtredelseId) => {
    if (valgtOvertredelseId === overtredelseId && !updateModalIsOpen) {
      setValgtOvertredelseId(undefined);
    } else if (valgtOvertredelseId !== overtredelseId && !updateModalIsOpen) {
      setValgtOvertredelseId(overtredelseId);
    }
  };

  const getKreverAvstandTekst = (kreverAvstand) => {
    if (kreverAvstand) return "JA";
    else if (kreverAvstand === false) return "VALGFRITT";
    else return "NEI";
  };

  const getCollapsibleArrow = (overtredelseskodeId) => {
    const icon =
      valgtOvertredelseId === overtredelseskodeId ? faCaretDown : faCaretRight;
    return (
      <FontAwesomeIcon
        icon={icon}
        size="lg"
        fixedWidth
        style={{ cursor: "pointer" }}
        onClick={() => toggleDetailRow(overtredelseskodeId)}
      />
    );
  };

  const headerRow = [
    "",
    "ID",
    "Forklaring",
    "Gruppe",
    "Beløp",
    "Krever meter",
    "Status",
    "",
  ];
  return (
    <Table
      id="overtredelseskoderIleggelse-liste"
      className="table-wrapper-horizontal-scroll-white-space-normal"
      headerRow={headerRow}
      defaultStyle
      stripedHeaderStyle
    >
      <tbody>
        {map(
          overtredelseskoderIleggelser,
          (overtredelseskoderIleggelse, index) => {
            const rowClassName =
              index % 2 === 0
                ? { backgroundColor: "#ffffff", color: "#4d4d4d" }
                : { backgroundColor: "#f3f3f3", color: "#4d4d4d" };

            const sanitizedForklaring = overtredelseskoderIleggelse.forklaring
              ? sanitizeHtml(
                  overtredelseskoderIleggelse.forklaring?.replaceAll(
                    "\n",
                    "<br>",
                  ),
                  ["br"],
                )
              : "";

            return (
              <React.Fragment
                key={`overtredelseskoderIleggelserTableBodyTr${overtredelseskoderIleggelse.id.toString()}`}
              >
                <tr
                  onClick={() =>
                    toggleDetailRow(overtredelseskoderIleggelse.id)
                  }
                  aria-controls="Toggles vis detalj"
                  style={{ ...rowClassName, cursor: "pointer" }}
                  tabIndex={0}
                >
                  <td>{getCollapsibleArrow(overtredelseskoderIleggelse.id)}</td>
                  <td>{overtredelseskoderIleggelse.id.toString()}</td>
                  <td>{overtredelseskoderIleggelse.beskrivelse}</td>
                  <td>{overtredelseskoderIleggelse.overtredelseGruppe.navn}</td>
                  <td>{overtredelseskoderIleggelse.belop}</td>
                  <td>
                    {getKreverAvstandTekst(
                      overtredelseskoderIleggelse.kreverAvstand,
                    )}
                  </td>
                  <td>{overtredelseskoderIleggelse.aktiv.aktivString}</td>
                  <td>
                    {(authorizedToCreateAndEdit || authorized(juridiskAll)) && (
                      <OvertredelseskoderIleggelserUpdateModal
                        isOpenCallback={setUpdateModalIsOpen}
                        overtredelsekoderIleggelse={overtredelseskoderIleggelse}
                      />
                    )}
                  </td>
                </tr>
                {valgtOvertredelseId === overtredelseskoderIleggelse.id && (
                  <tr>
                    <td colSpan={2} style={{ ...rowClassName, border: 0 }} />
                    <td colSpan={1} style={{ ...rowClassName, border: 0 }}>
                      <div style={{ display: "flex", columnGap: 10 }}>
                        <div style={{ fontWeight: 700, whiteSpace: "nowrap" }}>
                          Forklaring for innbyggere:
                        </div>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: sanitizedForklaring,
                          }}
                        />
                      </div>
                    </td>
                    <td colSpan={5} style={{ ...rowClassName, border: 0 }} />
                  </tr>
                )}
              </React.Fragment>
            );
          },
        )}
      </tbody>
    </Table>
  );
}
